import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from './MaterialIcon';
import './TagChip.css';

const TagChip = ({ tag, onRemove }) => {
  const handleRemove = (e) => {
    e.stopPropagation();
    onRemove();
  };

  return (
    <div className="tag-chip" role="button" tabIndex={0}>
      <span className="tag-text">{tag}</span>
      <button
        className="remove-btn"
        onClick={handleRemove}
        aria-label={`Remove ${tag} tag`}
        type="button"
      >
        <MaterialIcon icon="close" size={16} />
      </button>
    </div>
  );
};

TagChip.propTypes = {
  tag: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default TagChip;
